import classNames from 'classnames'
import React, { FC } from 'react'

interface PricingEntry {
  destination: string
  cost: string
}

type Props = {}

const CallForwardingCosts: FC<Props> = () => {
  const pricingData: PricingEntry[] = [
    { cost: '£0.04', destination: 'UK Landline' },
    { cost: '£0.07', destination: 'UK Mobile' },
    { cost: '£0.64', destination: 'UK Premium Mobile' },
    { cost: '£0.90', destination: 'UK Personal Numbers' },
    { cost: 'From £0.07', destination: 'UK Special Services' },
  ]

  const tableRowSpacing = 'py-8 px-4 px-lg-10 text-left'

  return (
    <div
      className='d-flex flex-column align-items-center align-self-center'
      style={{
        maxWidth: 712,
      }}
    >
      <div className='d-flex flex-column gap-3 text-center mb-17'>
        <h2 className='fs-fluid-36-80 lh-105 lh-lg-114 fw-semibold mb-0'>
          Virtual landline call forwarding costs
        </h2>
        <div className='fs-fluid-18-36 fw-semibold color-grey5'>
          Transparent pricing — no hidden fees
        </div>
      </div>

      <div>
        <table className='bg-white overflow-hidden w-100 mb-7 mb-lg-6 call-forwarding-table'>
          <thead className='fs-fluid-20-32 fw-semibold bg-grey2'>
            <tr>
              <th className={`border-end border-white${tableRowSpacing}`}>
                Destination
              </th>
              <th className={tableRowSpacing}>Cost Per Minute</th>
            </tr>
          </thead>
          <tbody>
            {pricingData.map((item, index) => (
              <tr key={index} className='fs-fluid-16-24'>
                <td
                  className={classNames(
                    'fw-semibold border-end ',
                    tableRowSpacing,
                    {
                      'border-grey8 border-bottom':
                        index !== pricingData.length - 1,
                    },
                  )}
                >
                  {item.destination}
                </td>
                <td
                  className={classNames('fw-bold', tableRowSpacing, {
                    'border-grey8 border-bottom':
                      index !== pricingData.length - 1,
                  })}
                >
                  {item.cost}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='fs-fluid-18-20 fw-semibold color-grey5 text-center px-lg-10 lh-114'>
        Our <span className='text-body'>pay-as-you-go pricing</span> means
        you're only charged for the time your forwarded calls are active.
        <br />
        No contracts and no unexpected charges.
      </div>
    </div>
  )
}

export default CallForwardingCosts
